import { action, ActionType } from 'typesafe-actions';
import { AuthModalTab } from '../../actions/app';

export const ACTIVATE = 'AUTH_MODAL/ACTIVATE';
export const DEACTIVATE = 'AUTH_MODAL/DEACTIVATE';

export const SELECT_TAB = 'AUTH_MODAL/SELECT_TAB';

export const lifecycle = {
  activate: () => action(ACTIVATE),
  deactivate: () => action(DEACTIVATE),
};

export const actions = {
  selectTab: (tab: AuthModalTab) => action(SELECT_TAB, { tab }),
};

export type Action = ActionType<typeof actions>;
